<div>
    <label>{{(label | mxTranslate)() + ': '}}</label>
    <label class="bold">{{('label.dashboard.commission.currency' | mxTranslate)() + ' ' + value }}</label>
</div>
